import React, { useEffect, useState } from 'react';
import { Button, Card, Col, DatePicker, Divider, Form, FormInstance, Input, Row, Select, Tag } from 'antd';
import './packing-stock-transfer.css';
import { PackingStockTransferMain } from './packing-stock-transfer-detail-from';
import { ItemCategoryDropDownDto, PlantsDropDown } from '@gtpl/shared-models/masters';
import { UnitcodeService } from "@gtpl/shared-services/masters";
import { AlertMessages } from '@gtpl/shared-utils/alert-messages';
import { Link, Route, useHistory } from "react-router-dom";

import PackingStockTransferItems from './packing-stock-transfer-items';
import { StockService, TransferMaterialService } from '@gtpl/shared-services/procurement'
import { UnitRequest } from '@gtpl/shared-models/common-models';
import { SaleOrderDropDownDto } from '@gtpl/shared-models/sale-management';
import { SaleOrderIdRequest } from '@gtpl/shared-models/procurement-management';
/* eslint-disable-next-line */
export interface PackingStockTransferProps { }


export function PackingStockTransfer(
  props: PackingStockTransferProps
) {
  let history = useHistory();

  const [stockTransferForm] = Form.useForm<any>();
  const [stockTransferItemsForm] = Form.useForm<any>();
  const [stKey, setStKey] = useState<number>(0);
  const [stItemKey, setStItemKey] = useState<number>(1);
  const [disabled, setDisabled] = useState<boolean>(false);

  const [plantInfo, setPlantInfo] = useState<PlantsDropDown[]>([]);
  const [fromPlant, setFromPlant] = useState<string>('');
  const [itemCategories, setItemCategories] = useState<ItemCategoryDropDownDto[]>([]);
  const [isSo, setIsSo] = useState<boolean>(false);

  const [stItems, setStItems] = useState<any[]>([]);
  const [availableQty, setAvailableQty] = useState<number>(0);

  const unitService = new UnitcodeService();
  const skService = new StockService();
  const tMService = new TransferMaterialService();

  const isSoTransfer = (type) => {
    setIsSo(type)
  }

  const getAllPlants = () => {
    unitService.getAllMainPlants().then((res) => {
      if (res.status) {
        setPlantInfo(res.data);
        res.data.map((plant) => {
          if (plant.plantId == Number(localStorage.getItem('unit_id'))) {
            setFromPlant(plant.plantName);
          }
        })
      } else {
        setPlantInfo([]);
      }
    }).catch((err) => {
      AlertMessages.getErrorMessage(err.message);
      setPlantInfo([]);
    });
  }

  useEffect(() => {
    getAllPlants();
    getItemCategories();
  }, []);

  const getItemCategories = () => {
    const req = new UnitRequest(Number(localStorage.getItem('unit_id')));
    skService.getAvailableStockItemCategories(req).then((res) => {
      if (res.status) {
        setItemCategories(res.data);

      } else {
        setItemCategories([]);
      }
    }).catch((err) => {
      AlertMessages.getErrorMessage(err.message);
      setItemCategories([]);
    });
  }



  const getSaleOrderItems = () => {
    stockTransferItemsForm.resetFields();
    setStItems([]);
    setAvailableQty(0);
    const getSoId = stockTransferForm.getFieldValue('saleOrderId');
    if (getSoId) {
      stockTransferItemsForm.resetFields();
      setStItems([]);
      setAvailableQty(0);
      const req = new SaleOrderIdRequest(getSoId, Number(localStorage.getItem('unit_id')),0,"StockTransfer");
      tMService.getSaleOrderRequiredItemDetails(req).then((res) => {
        if (res.status) {
          setStItems(res.data);
        } else {
          AlertMessages.getErrorMessage(res.internalMessage);
          setStItems([]);
        }
      }).catch((err) => {
        AlertMessages.getErrorMessage(err.message);
        setStItems([]);
      });
    } {
      stockTransferItemsForm.resetFields();
      setStItems([]);
      setAvailableQty(0);
    }

  }

  const saveStockTransfer = () => {
    stockTransferForm.validateFields().then((formInfo) => {
      if (stItems && stItems.length) {
        setDisabled(true);
        formInfo.fromPlant = Number(localStorage.getItem('unit_id'));
        formInfo.createdUser = localStorage.getItem('createdUser');
        formInfo.stockTransferItems = stItems;
        tMService.createTransferMaterial(formInfo).then((res) => {
          if (res.status) {
            AlertMessages.getSuccessMessage(res.internalMessage);
            history.push('./stock-transfer-grid');
          } else {
            AlertMessages.getErrorMessage(res.message);
          }
          setDisabled(false);
        }).catch((err) => {
          setDisabled(false);
          AlertMessages.getErrorMessage(err.message);
        });
      } else {
        AlertMessages.getErrorMessage("Please Select Items");
      }
    })
  }

  const addItems = (items) => {
    setStItems(items);
    setStItemKey(stItemKey + 1)
  }

  return (
    <Card size="small" title={<span style={{ color: 'white' }}>Stock Transfer</span>}
      style={{ textAlign: 'center' }} headStyle={{ backgroundColor: '#69c0ff', border: 0 }} extra={<><Tag style={{ backgroundColor: '#f6e552', color: "black", fontWeight: 'bold' }}>{fromPlant}</Tag><Divider type="vertical" /><Link to='/stock-transfer-grid'><span style={{ color: 'white' }}><Button className='panel_button'>View </Button> </span></Link></>}>
      <PackingStockTransferMain key={stKey} plantInfo={plantInfo} itemCategories={itemCategories} form={stockTransferForm} getSaleOrderItems={getSaleOrderItems} isSoTransfer={isSoTransfer} />
      <PackingStockTransferItems key={stItemKey} itemCategories={itemCategories} form={stockTransferItemsForm} stItems={stItems} addItems={addItems} availQty={availableQty} isSo={isSo} />
      <Row justify="end">
        <Col>
          <Form.Item style={{ display: (disabled || (stItems.length) ? 'block' : 'none') }}>
            <Button type='primary' onClick={saveStockTransfer} block disabled={disabled || (stItems.length) ? false : true}>
              Submit
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Card>
  );
}

export default PackingStockTransfer;
